export { default as FunnelFilter } from "./funnel-filter.component";
export { default as OpportunitiesTable } from "./opportunities-table.component";
export { default as OpportunitiesPhases } from "./opportunities-phases.component";